export default __webpack_public_path__ + "static/media/login.57b8e037.png";